var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmojioneFlagForUnitedStates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 4.125C27.0625 2.3125 23.6875 1.25 20 1.25V4.125H30Z",
    fill: "#ED4C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 7H33.5C32.4375 5.9375 31.25 4.9375 30 4.125H20V7Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.875H35.8125C35.125 8.8125 34.375 7.875 33.5625 7H20V9.875Z",
    fill: "#ED4C5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.75H37.3125C36.875 11.75 36.375 10.75 35.8125 9.875H20V12.75Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.625H38.25C38 14.625 37.6875 13.6875 37.3125 12.75H20V15.625Z",
    fill: "#ED4C5C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.5625H38.6875C38.625 17.5625 38.4375 16.625 38.25 15.6875H20V18.5625Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6875 18.5625H20V20H1.25C1.25 20.5 1.25 20.9375 1.3125 21.4375H38.6875C38.75 20.9375 38.75 20.5 38.75 20C38.75 19.5 38.75 19 38.6875 18.5625Z",
    fill: "#ED4C5C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 24.3125H38.25C38.5 23.375 38.625 22.4375 38.6875 21.4375H1.3125C1.375 22.375 1.5 23.375 1.75 24.3125Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6875 27.1875H37.3125C37.6875 26.25 38 25.3125 38.25 24.3125H1.75C2 25.3125 2.3125 26.25 2.6875 27.1875Z",
    fill: "#ED4C5C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1875 30.0625H35.8125C36.375 29.125 36.875 28.1875 37.3125 27.1875H2.6875C3.125 28.1875 3.625 29.125 4.1875 30.0625Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4375 32.9375H33.5625C34.375 32.0625 35.1875 31.0625 35.8125 30.0625H4.1875C4.8125 31.125 5.625 32.0625 6.4375 32.9375Z",
    fill: "#ED4C5C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9375 35.8125H30.0625C31.375 35 32.5 34 33.5625 32.9375H6.4375C7.5 34.0625 8.6875 35 9.9375 35.8125Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20 38.75C23.6875 38.75 27.125 37.6875 30.0625 35.8125H9.9375C12.875 37.6875 16.3125 38.75 20 38.75Z",
    fill: "#ED4C5C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.125C8.6875 4.9375 7.5 5.9375 6.4375 7C5.5625 7.875 4.8125 8.875 4.1875 9.875C3.625 10.8125 3.0625 11.75 2.6875 12.75C2.3125 13.6875 2 14.625 1.75 15.625C1.5 16.5625 1.375 17.5 1.3125 18.5C1.25 19 1.25 19.5 1.25 20H20V1.25C16.3125 1.25 12.9375 2.3125 10 4.125Z",
    fill: "#428BC1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 1.875L15.9375 2.8125H16.875L16.125 3.4375L16.375 4.375L15.625 3.8125L14.875 4.375L15.125 3.4375L14.375 2.8125H15.3125L15.625 1.875Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 5.625L18.4375 6.5625H19.375L18.625 7.1875L18.875 8.125L18.125 7.5625L17.375 8.125L17.625 7.1875L16.875 6.5625H17.8125L18.125 5.625Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 5.625L13.4375 6.5625H14.375L13.625 7.1875L13.875 8.125L13.125 7.5625L12.375 8.125L12.625 7.1875L11.875 6.5625H12.8125L13.125 5.625Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 9.375L15.9375 10.3125H16.875L16.125 10.9375L16.375 11.875L15.625 11.3125L14.875 11.875L15.125 10.9375L14.375 10.3125H15.3125L15.625 9.375Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 9.375L10.9375 10.3125H11.875L11.125 10.9375L11.375 11.875L10.625 11.3125L9.875 11.875L10.125 10.9375L9.375 10.3125H10.3125L10.625 9.375Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 9.375L5.9375 10.3125H6.875L6.125 10.9375L6.375 11.875L5.625 11.3125L4.875 11.875L5.125 10.9375L4.375 10.3125H5.3125L5.625 9.375Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 13.125L18.4375 14.0625H19.375L18.625 14.6875L18.875 15.625L18.125 15.0625L17.375 15.625L17.625 14.6875L16.875 14.0625H17.8125L18.125 13.125Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 13.125L13.4375 14.0625H14.375L13.625 14.6875L13.875 15.625L13.125 15.0625L12.375 15.625L12.625 14.6875L11.875 14.0625H12.8125L13.125 13.125Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 13.125L8.4375 14.0625H9.375L8.625 14.6875L8.875 15.625L8.125 15.0625L7.375 15.625L7.625 14.6875L6.875 14.0625H7.8125L8.125 13.125Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 16.875L15.9375 17.8125H16.875L16.125 18.4375L16.375 19.375L15.625 18.8125L14.875 19.375L15.125 18.4375L14.375 17.8125H15.3125L15.625 16.875Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 16.875L10.9375 17.8125H11.875L11.125 18.4375L11.375 19.375L10.625 18.8125L9.875 19.375L10.125 18.4375L9.375 17.8125H10.3125L10.625 16.875Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 16.875L5.9375 17.8125H6.875L6.125 18.4375L6.375 19.375L5.625 18.8125L4.875 19.375L5.125 18.4375L4.375 17.8125H5.3125L5.625 16.875Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M7.375 8.125L8.125 7.5625L8.875 8.125L8.5625 7.1875L9.3125 6.5625H8.375L8.125 5.625L7.8125 6.5625H6.9375L7.6875 7.125L7.375 8.125Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 15.625L3.125 15.0625L3.875 15.625L3.5625 14.6875L4.3125 14.0625H3.4375L3.125 13.125L2.8125 14.0625H2.1875C2.1875 14.125 2.125 14.1875 2.125 14.25L2.625 14.625L2.375 15.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojioneFlagForUnitedStates);
export default __webpack_public_path__ + "static/media/emojione_flag-for-united-states.f57671a5655dfbbbfddb4c4943744f1e.svg";
export { ForwardRef as ReactComponent };